module.exports = __webpack_public_path__ + "img/77a6186.png";